import React from 'react';
import { motion } from 'framer-motion';
function FooterLeaf() {
  return <svg viewBox="0 0 40 60" className="w-8 h-12 text-cream/30" aria-hidden="true" data-id="element-23">
      <path d="M20 5C20 5 8 18 8 32C8 46 20 55 20 55C20 55 32 46 32 32C32 18 20 5 20 5Z" fill="currentColor" data-id="element-24" />
      <path d="M20 10V50" stroke="currentColor" strokeWidth="1" opacity="0.5" data-id="element-25" />
    </svg>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-olive-dark text-cream" data-id="element-26">
      <div className="max-w-6xl mx-auto px-6 py-16" data-id="element-27">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8" data-id="element-28">
          {/* Brand */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="lg:col-span-1" data-id="element-29">
            <div className="flex items-center gap-3 mb-4" data-id="element-30">
              <FooterLeaf data-id="element-31" />
              <span className="font-serif text-2xl font-medium" data-id="element-32">Botanical</span>
            </div>
            <p className="font-sans text-cream/70 text-sm leading-relaxed" data-id="element-33">
              A sanctuary for body and mind, where nature's wisdom guides your
              journey to wellness.
            </p>
          </motion.div>

          {/* Services */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} viewport={{
          once: true
        }} data-id="element-34">
            <h4 className="font-serif text-lg font-medium mb-4" data-id="element-35">Services</h4>
            <ul className="space-y-2 font-sans text-sm" data-id="element-36">
              <li data-id="element-37">
                <a href="#services" className="text-cream/70 hover:text-cream transition-colors" data-id="element-38">
                  Aromatherapy Massage
                </a>
              </li>
              <li data-id="element-39">
                <a href="#services" className="text-cream/70 hover:text-cream transition-colors" data-id="element-40">
                  Lymphatic Drainage
                </a>
              </li>
              <li data-id="element-41">
                <a href="#services" className="text-cream/70 hover:text-cream transition-colors" data-id="element-42">
                  Trigger Point Therapy
                </a>
              </li>
              <li data-id="element-43">
                <a href="#services" className="text-cream/70 hover:text-cream transition-colors" data-id="element-44">
                  Somatic Bodywork
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Quick Links */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} viewport={{
          once: true
        }} data-id="element-45">
            <h4 className="font-serif text-lg font-medium mb-4" data-id="element-46">Quick Links</h4>
            <ul className="space-y-2 font-sans text-sm" data-id="element-47">
              <li data-id="element-48">
                <a href="#philosophy" className="text-cream/70 hover:text-cream transition-colors" data-id="element-49">
                  Our Philosophy
                </a>
              </li>
              <li data-id="element-50">
                <a href="#location" className="text-cream/70 hover:text-cream transition-colors" data-id="element-51">
                  Location & Hours
                </a>
              </li>
              <li data-id="element-52">
                <a href="#location" className="text-cream/70 hover:text-cream transition-colors" data-id="element-53">
                  Book a Session
                </a>
              </li>
              <li data-id="element-54">
                <a href="#" className="text-cream/70 hover:text-cream transition-colors" data-id="element-55">
                  Gift Cards
                </a>
              </li>
            </ul>
          </motion.div>

          {/* Contact */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} viewport={{
          once: true
        }} data-id="element-56">
            <h4 className="font-serif text-lg font-medium mb-4" data-id="element-57">Contact</h4>
            <address className="font-sans text-sm text-cream/70 not-italic space-y-2" data-id="element-58">
              <p data-id="element-59">Gartenstraße 42</p>
              <p data-id="element-60">10115 Berlin, Germany</p>
              <p className="pt-2" data-id="element-61">
                <a href="tel:+4930123456789" className="hover:text-cream transition-colors" data-id="element-62">
                  +49 30 123 456 789
                </a>
              </p>
              <p data-id="element-63">
                <a href="mailto:hello@botanicalwellness.de" className="hover:text-cream transition-colors" data-id="element-64">
                  hello@botanicalwellness.de
                </a>
              </p>
            </address>
          </motion.div>
        </div>

        {/* Bottom bar */}
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} viewport={{
        once: true
      }} className="mt-12 pt-8 border-t border-cream/10" data-id="element-65">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4" data-id="element-66">
            <p className="font-sans text-sm text-cream/50" data-id="element-67">
              © {currentYear} Botanical Wellness. All rights reserved.
            </p>
            <div className="flex gap-6 font-sans text-sm" data-id="element-68">
              <a href="#" className="text-cream/50 hover:text-cream transition-colors" data-id="element-69">
                Privacy Policy
              </a>
              <a href="#" className="text-cream/50 hover:text-cream transition-colors" data-id="element-70">
                Terms of Service
              </a>
              <a href="#" className="text-cream/50 hover:text-cream transition-colors" data-id="element-71">
                Impressum
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </footer>;
}